import React from 'react';
import type { ItemSidebarComponentGlobalType, TemplateSlug } from '../types';
import Feature from './feature';
import ProgrammableComponent from './ProgrammableComponent';
import ProductSelection from './productSelection';
import LinkCollection from './linkCollection';
import ItemSelection from './itemSelection';
import Sponso from './Sponso';
import SectionSelection from './SectionSelection';

const component: { [key in TemplateSlug]: React.FC<ItemSidebarComponentGlobalType> } = {
  feature: Feature,
  programmable_component: ProgrammableComponent,
  product_selection: ProductSelection,
  link_collection: LinkCollection,
  item_selection: ItemSelection,
  software_modal_3_columns: Sponso,
  section_selection: SectionSelection,
};

export default component;
